import React, { FC, useState } from 'react';
import Button from '~ComponentsImproved/Button';
import NumberInput from '~ComponentsImproved/Numpad';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { useCurrency, useI18n } from '~Hooks';
import { Box } from '~Styles';

interface Props {
  currentTip: number;
  newTipAmount: number | null;
  setNewTipAmount: (amount: number) => void;
}

const TipRefund: FC<Props> = ({ currentTip, newTipAmount, setNewTipAmount }) => {
  const [showTipAmountInput, setShowTipAmountInput] = useState(false);
  const { i18n } = useI18n();
  const currency = useCurrency();

  return (
    <div>
      <Heading level={2} color="var(--colorBlueGray50)" bottom={24}>
        {i18n('Refunds.TipRefund.Title')}
      </Heading>
      <Box display="flex" justifyContent="space-between" marginBottom="large">
        <Heading level={4} color="var(--colorBlueGray50)">
          {i18n('Refunds.CurrentTip')}:
        </Heading>
        <Paragraph level={3} color="var(--colorBlueGray50)">
          {currency.format(currentTip)}
        </Paragraph>
      </Box>

      {newTipAmount !== null && (
        <div>
          <Box display="flex" justifyContent="space-between" marginBottom="small">
            <Heading level={4} color="var(--colorBlueGray50)">
              {i18n('Refunds.NewTip')}:
            </Heading>
            <Paragraph level={3} color="var(--colorBlueGray50)">
              {currency.format(newTipAmount)}
            </Paragraph>
          </Box>

          <Box display="flex" justifyContent="space-between" marginBottom="large">
            <Heading level={4} color="var(--colorBlueGray50)">
              {i18n('Refunds.Tip.AmountToRefund')}:
            </Heading>
            <Paragraph level={3} color="var(--colorBlueGray50)">
              {currency.format(currentTip - newTipAmount)}
            </Paragraph>
          </Box>
        </div>
      )}

      {newTipAmount === null && (
        <Button
          styleType="Default"
          text={i18n('Refunds.Tip.SetNewAmount')}
          onTouchStart={() => setShowTipAmountInput(true)}
        />
      )}

      {showTipAmountInput && (
        <NumberInput
          onSubmit={(val) => {
            setNewTipAmount(Math.round(parseFloat(val) * 100));
            setShowTipAmountInput(false);
          }}
          decimal
          maxValue={currentTip / 100}
          onClose={() => setShowTipAmountInput(false)}
        />
      )}
    </div>
  );
};

export default TipRefund;
